import React from 'react';
import { useTranslation } from 'react-i18next';
import Overlay from '../components/common/Overlay';
import { useAppSelector } from '../hooks/store';
import Categories from '../components/common/Categories';
import Info from '../components/common/Info';
import AvatarForm from '../components/profile/AvatarForm';


const InfoView = () => {
	const { t, i18n } = useTranslation();
	const name = i18n.language === 'en' ? 'name_en' : 'name_ru';
    const user = useAppSelector(store => store.auth.user);

    if(!user) return <div className='error'>{t('common.nouser')}</div>;

    return (
		<Overlay>
            <h1>{t('profile.title.view')}</h1>
            <div className='Profile'>
                <div className='Info'>
                    <div className='Name'>{user[name]}</div>
                    <div className='Email'>{user.email}</div>
                </div>
                <div className='Avatar'>
                    <AvatarForm/>
                </div>
            </div>
            <Info attendee={user}/>
            <Categories attendee={user}/>
		</Overlay>
	);
};

export default InfoView;
